import React from "react";
import { Checkbox, Box, IconButton, Icon } from "@chakra-ui/react";
import {
  service,
  toggleFeature,
} from "@uidaholib/shared/machines/map/map.machine";
import { useService } from "@xstate/react";
import { useToggle } from "react-use";
import { observer } from "mobx-react-lite";
import { featureStore } from "@uidaholib/shared/models/features/features";
import { Analytic } from "@uidaholib/shared/api/analytics";
import { configStore } from "@uidaholib/shared/models/config/config";

const FeatureIcon = observer(
  ({ field, onIcon, offIcon, feature, preventSelection = false }) => {
    const [state, send] = useService(service);

    const [isOn, toggle] = useToggle(feature[field]);

    const isDisabled =
      featureStore.hasReachedMaxSelection(field) &&
      !featureStore.selection[field].includes(feature.label);

    const config = configStore.getConfig();

    const onSelected = (selected) => {
      feature.toggle("selected", selected, feature);
      Analytic.sendEvent({
        label: feature.label,
        category: `${config.analytics.layers.category}-${field}`,
        action: config.analytics.layers.filter,
      });
    };

    const performAction = (selected) => {
      const { view, imagery } = state.context;
      feature.toggle(field, selected, feature);
      feature.performAction({ enabled: !selected, imagery, view, field });
    };

    if (field === "selected")
      return (
        <Checkbox
          key={feature.label}
          value={feature[field]}
          onChange={(e) => onSelected(e.target.checked)}
          isChecked={feature[field]}
          isDisabled={feature.disabled}
        >
          {feature.label}
        </Checkbox>
      );
    else
      return (
        <Icon
          aria-label={`"layer action icon" ${field}`}
          as={isOn ? onIcon : offIcon}
          mr={2}
          disabled={isDisabled}
          boxSize="24px"
          color={isOn ? "green.600" : "gray.500"}
          onClick={() => {
            if (isDisabled) return;
            toggle();
            performAction(isOn);
          }}
          cursor="pointer"
          opacity={
            (field === "footprintEnabled" && feature.hideFootprint()) ||
            (field === "naturalColored" && !feature.visible)
              ? 0.5
              : 1
          }
          _last={{ mr: 0 }}
          visibility={
            field === "naturalColored" && !feature.hasNaturalColor
              ? "hidden"
              : "visible"
          }
        />
      );
  }
);

export default FeatureIcon;
